import React from 'react';
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

type BackButtonProps = {
  show: boolean;
};

const BackButton: React.FC<BackButtonProps> = ({ show }) => {
  const navigate = useNavigate();
  if (!show) return null;

  return (
    <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
      <ArrowBackIcon />
    </IconButton>
  );
};

export default BackButton;
